// Import dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Action } from 'history';

class SearchInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      query: props.query,
    };
  }

  componentDidMount() {
    const { history } = this.props;

    this.unlisten = history.listen(({ location, action }) => {
      if (action === Action.Pop) {
        this.setState({ query: new URLSearchParams(location.search).get('q') || null });
        this.search(false);
      }
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.search();
  };

  search = (hPush = true) => {
    const { searchFn, history } = this.props;
    const { query } = this.state;

    if (hPush) history.push({ search: `?q=${query}` });

    searchFn({ variables: { needle: query } });
  };

  handleChange = (e) => {
    this.setState({ query: e.target.value });
  };

  render() {
    const { onSubmit } = this;
    const { query } = this.state;
    const { inputId } = this.props;

    return (
      <div className="c-search-input">
        <form className="c-search-input__form">
          <fieldset>
            <label htmlFor={inputId} className="u-visually-hidden">Search keyword or phrase</label>
            <div className="c-search-input__field">
              <svg>
                <use xlinkHref="#search" />
              </svg>
              <input
                onChange={this.handleChange}
                value={query}
                type="text"
                className="c-search-input__input"
                placeholder="Search"
                id={inputId}
                required
              />
            </div>
          </fieldset>
          <button className="c-search-input__button" type="submit" onClick={onSubmit} title="Search">Search</button>
        </form>
      </div>
    );
  }
}

SearchInput.propTypes = {
  query: PropTypes.string.isRequired,
  searchFn: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
    listen: PropTypes.func,
  }).isRequired,
  inputId: PropTypes.string.isRequired,
};

SearchInput.defaultProps = {
  searchFn: () => {
    // eslint-disable-next-line no-console
    console.error('SearchFn prop failed to pass');
  },
};

export default SearchInput;
